import smoothscroll from "smoothscroll-polyfill";

// Edge needs polyfill for `scrollTo`
smoothscroll.polyfill();
